/** Stable wizard-state key for one editable company CSV field. */
export function companyCellEditKey(rowIndex: number, header: string): string {
  return `${rowIndex}:${header}`;
}
